import React, { useEffect, useState } from "react";
import { BorderColor } from "@mui/icons-material";
import Button from "../Button";
import { Collection, CollectionState } from "../../types";
import { IMAGE_KIT_ENDPOINT_URL, } from "../../constants";
import { useAuth } from "../../contexts/AuthContext";



type Props = {
  collection: Collection;
  onClick: (collection: Collection) => void;
  state?: CollectionState
};

const NotificationListItem = React.memo(({ collection, onClick, state }: Props) => {
  const [thumbnailHttpUrl, setThumbnailHttpUrl] = useState<string>();
  const { isCurrentUserAdmin } = useAuth();
  const isAdmin = isCurrentUserAdmin();

  useEffect(() => {
    (async () => {
if (collection?.thumbnailUrl?.includes("thumbnails/")) {
        setThumbnailHttpUrl(
          `${IMAGE_KIT_ENDPOINT_URL}${collection?.thumbnailUrl}`
        );
      } else {
        setThumbnailHttpUrl(collection?.thumbnailUrl);
      }
    })();
  }, [collection?.thumbnailUrl, setThumbnailHttpUrl]);


  return (
    <div
      onClick={() => onClick(collection)}
      className="rounded-3xl bg-kyzzen-secondary md:shadow-lg p-6 flex flex-row mb-8 justify-between cursor-pointer"
    >
      <div className="flex items-start">
        <img
          src={
            thumbnailHttpUrl
              ? thumbnailHttpUrl
              : "/assets/logo/default-digitaleyes-icon.jpeg"
          }
          alt={collection?.name + "logo"}
          className="rounded-md h-auto w-28 mr-6"
        />
        <div>
          <h4 className="uppercase font-medium text-lg">{collection.name}</h4>
          <p className="font-light text-base mt-2 mb-1">
            {collection?.stage === "rejected" 
              ? collection?.rejectionNote &&
              `Rejection note: ${collection?.rejectionNote}`
              : collection?.creatorNotes &&
              `Note: ${collection?.creatorNotes}`}
          </p>
          <p className="font-light text-base mt-2 mb-1">
            {isAdmin && state === CollectionState.deleted
              && collection?.deletionNotes &&
              `Deletion note: ${collection?.deletionNotes}`
            }
          </p>
          <p className="text-sm font-light mt-2 text-gray-40">
            {state === CollectionState.deleted
              && collection?.deletedBy &&
              `Deleted By: ${collection?.deletedBy}`
            }
          </p>
          {isAdmin && collection?.creatorEmail && (
            <h4 className="text-sm font-light mt-2 text-gray-40">
              {`Submitted by ${collection?.creatorEmail}`}
            </h4>
          )}
          {collection?.createdAt && state !== CollectionState.deleted && (
            <>
              <h4 className="text-sm font-light mt-1 text-gray-40">
                {`Updated on ${new Date(collection.createdAt).toDateString()}`}
              </h4>
              <h4 className="text-sm font-light text-gray-40">{new Date(collection.createdAt).toLocaleTimeString()}</h4>
            </>
          )}
        </div> 
      </div>
      <div>
        <Button type="button" className="text-blue w-full text-sm">
          <BorderColor className="h-4  text-gray-40" />
        </Button>
      </div>
    </div>
  );
});

export default NotificationListItem;
